import { render } from "./vsetphotoexamine.vue?vue&type=template&id=1998312e&scoped=true"
import script from "./vsetphotoexamine.vue?vue&type=script&lang=js"
export * from "./vsetphotoexamine.vue?vue&type=script&lang=js"

import "./vsetphotoexamine.vue?vue&type=style&index=0&id=1998312e&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1998312e"]])

export default __exports__